import React, { PropsWithChildren } from 'react';
import { ApolloProvider } from '@apollo/client';
import { client } from '../helpers';
import { UtilsProvider } from './UtilsProvider';
import { AuthProvider } from './AuthProvider';
import { NotificationProvider } from './NotificationProvider';

export const AppMainProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <ApolloProvider client={client}>
    <UtilsProvider>
      <AuthProvider>
        <NotificationProvider>{children}</NotificationProvider>
      </AuthProvider>
    </UtilsProvider>
  </ApolloProvider>
);
